import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocationState } from 'src/modules/user-input/useLocationState.ts';

export const PageLegacy = ({ pathname }: { pathname: string }) => {
    const navigate = useNavigate();
    const { page, valveLabel, actuatorLabel } = useParams();
    const [locationState, setLocationState] = useLocationState();
    useEffect(() => {
        const search = setLocationState({
            ...locationState,
            valveLabel: valveLabel !== undefined ? valveLabel : locationState.valveLabel,
            actuatorLabel: actuatorLabel !== undefined ? actuatorLabel : locationState.actuatorLabel,
            valvesPage: page !== undefined ? page : locationState.valvesPage,
        });
        navigate({
            pathname,
            search: search.toString(),
        });
    }, [navigate, valveLabel, page, locationState, setLocationState, actuatorLabel, pathname]);
    return 'redirecting';
};
